import { render, staticRenderFns } from "./seller-data.vue?vue&type=template&id=26648655&scoped=true"
import script from "./seller-data.vue?vue&type=script&lang=js"
export * from "./seller-data.vue?vue&type=script&lang=js"
import style0 from "./seller-data.vue?vue&type=style&index=0&id=26648655&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26648655",
  null
  
)

export default component.exports